import * as PIXI from 'pixi.js';

const [clientRect] = document.body.getClientRects();

export const WIDTH = 1792/*clientRect.width*/, HEIGHT = 927/*clientRect.height*/;
export const SMALLEST_FRACTION = 64;
export const THREE_FOV = 45;
export const THREE_DRAW_DISTANCE = 1000;

export const style = new PIXI.TextStyle({
    fontFamily: 'Bravura',
    fontSize: 86,
    // fill: ['#ffffff', '#ff9900'], // gradient
    fill: ['0x000000'],
    align: 'center',
    lineHeight: 200
});

export const styleSmall = new PIXI.TextStyle({
    ...style,
    fontSize: 20,
});
export const styleTimeSignature = new PIXI.TextStyle({
    ...style,
    fontSize: 60,
});

export const DEFAULT_SETTINGS = {
    godMode: false,
    musicVolume: 1,
    pianoVolume: -20,
    metronomeVolume: -20,
    offset: 0,
    blackGemColor: 0x000000,
    whiteGemColor: 0xFFFFFF,
    sustainTailColor: 0x0000FF,
    backgroundColorSequence: [
        0x7D1309,
        0xAA190C,
        0xB80F00,

        0xD6FB2F,
        0xDAFB48,
        0xDCFF42,
        0xE2FF62,

        0x0A328C,
        0x0D40B6,
        0x003AC2,

        0x219828,
        0x29B932,
        0x00E00F,
        0x12FF22
    ],
    lineMaterialColor1: 0xaaffff,
    lineMaterialColor2: 0xaaffff,
    rayMaterialColor: 0xa3f7b5,
    pianoConfig: {
        title: 'DEFAULT PIANO',
        boundaries: {
            min: 28,
            max: 64
        }
    }
}